/**
 * Some logic to get the env name
 */
export function getEnv() {
  return process.env.REACT_APP_BUILD_ENV;
}

export function isPendoEnabled(): boolean {
  return !!process.env.PENDO_ENABLED;
}
